import { z } from "zod";
import type { Operation } from "../types";

// Attachments — the create-modal paperclip. One endpoint: upload a batch of
// files (bytes base64-encoded in the JSON body, the no-multipart rail) and link
// them to a just-created entity. The active workspace is resolved server-side.

const uploadFile = z.object({
  name: z.string().min(1),
  mime: z.string().optional(),
  dataBase64: z.string().min(1),
});

const uploadBody = z.object({
  /** The entity to attach to (e.g. "task", "goal", "person", "organization"). */
  entityKind: z.string().min(1),
  /** The entity's LOCAL numeric id (attachments key on the integer id). */
  entityId: z.coerce.number().int().positive(),
  files: z.array(uploadFile).min(1).max(50),
});
export type AttachmentUploadBody = z.infer<typeof uploadBody>;

const uploadResponse = z.object({
  attachments: z.array(
    z.object({
      id: z.number(),
      filename: z.string(),
      storage_ref: z.string(),
    }),
  ),
});
export type AttachmentUploadResult = z.infer<typeof uploadResponse>;

const upload: Operation<void, void, AttachmentUploadBody, AttachmentUploadResult> = {
  method: "POST",
  path: () => "/api/attachments/upload",
  body: uploadBody,
  response: uploadResponse,
};

export const attachments = {
  upload,
};
